enum TemplateType {
  ASSESSMENT = 'ASSESSMENT',
  QA = 'QA',
}

export default TemplateType;
